export const isLocalStoryBook = () => {
  return (
    typeof window !== "undefined" && window.location.host === "localhost:6006"
  );
};

export default isLocalStoryBook;
